var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Manage people tags"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.vm.newTag,
                          expression: "vm.newTag",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "new tag..." },
                      domProps: { value: _vm.vm.newTag },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.vm, "newTag", $event.target.value.trim())
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button", disabled: !_vm.vm.newTag },
                          on: { click: _vm.handleCreateProjectUsersTag },
                        },
                        [_vm._v("Create tag")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.vm.createError)),
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "table table-hover mt-4" }, [
                    _c(
                      "tbody",
                      _vm._l(_vm.tagsView, function (t) {
                        return _c("tr", { key: t.tag }, [
                          _c("td", [
                            !t.editing
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "editable editable-secondary",
                                    on: {
                                      click: function ($event) {
                                        return t.edit()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(t.tag))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            t.editing
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: t.renamedTag,
                                      expression: "t.renamedTag",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: { value: t.renamedTag },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        t,
                                        "renamedTag",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            t.editing && _vm.updateError
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(_vm._s(_vm.updateError)),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              staticStyle: { width: "100px" },
                            },
                            [
                              !t.editing
                                ? _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-sm",
                                        attrs: {
                                          type: "button",
                                          title: "delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDeleteProjectUsersTag(
                                              t.tag
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-trash-can",
                                        }),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              t.editing
                                ? _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: {
                                          type: "button",
                                          title: "confirm",
                                          disabled: !t.canSave,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUpdateProjectUsersTag(
                                              t
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "fa fa-check",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-sm",
                                        attrs: {
                                          type: "button",
                                          title: "cancel",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return t.cancelEdit()
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "fa fa-times",
                                        }),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }